import { TitleEntity, VersionGroupedByParent } from '@/redux/slices/slice_types';

export const isObjectAVersion = (obj: TitleEntity | VersionGroupedByParent): obj is TitleEntity => {
  return Boolean(obj.id);
};
